/**
 * Centralized role → permission model for Kong Interface UI.
 * Mirrors api/internal/rbac/permissions.go — keep both in sync.
 */

export type Role = 'ADMIN' | 'SUPPORT'

export type Permission = 'users:read' | 'users:write' | 'write'

const rolePermissions: Record<Role, ReadonlySet<Permission>> = {
  ADMIN: new Set(['users:read', 'users:write', 'write']),
  SUPPORT: new Set(['users:read']),
}

export function hasPermission(role: string | undefined | null, permission: Permission): boolean {
  if (!role || !(role in rolePermissions)) {
    return false
  }
  return rolePermissions[role as Role].has(permission)
}

/** General mutating operations outside the Users module. */
export function canWrite(role: string | undefined | null): boolean {
  return hasPermission(role, 'write')
}

/** Create / edit / delete users and invites. */
export function canManageUsers(role: string | undefined | null): boolean {
  return hasPermission(role, 'users:write')
}

/** View Users list and details. */
export function canReadUsers(role: string | undefined | null): boolean {
  return hasPermission(role, 'users:read')
}
